import React, { FC, useEffect, useRef } from 'react'
import { observer } from 'mobx-react'
import { IonModal, IonHeader, IonContent } from '@ionic/react'
import { memberMobx } from '@mobxStore'
import JsBarcode from 'jsbarcode'
import './index.scss'

interface IProps {
  data: any[];
  value: any;
  visible: boolean;
  onClose: () => void;
  onChange: (val: any) => void;
}

const CouponType: FC<IProps> = (props: IProps) => {
  const {
    data,
    value,
    visible,
    onClose,
    onChange,
  } = props
  const barcodeRef = useRef<any>(null)
  const { memberInfo } = memberMobx
  useEffect(() => {
    if (memberInfo && barcodeRef.current) {
      JsBarcode(barcodeRef.current, `${memberInfo.memberId}`, {
        displayValue: false,
        width: 3,
        height: 70,
        margin: 8,
      })
    }
  }, [visible, memberInfo, barcodeRef])
  return (
    <IonModal
      cssClass='coupon-type-modal'
      isOpen={visible}
      showBackdrop
      swipeToClose
      backdropDismiss
      onDidDismiss={onClose}
    >
      <IonHeader className='modal-header'>
        <span>{i18n.t('mkt.coupon.chooseCate')}</span>
        <i className='iconfont icon-close' onClick={onClose}></i>
      </IonHeader>
      <IonContent className='type-panel'>
        {
          data.map((item: any) => {
            return (
              <div
                className='type-area' key={item.value} onClick={() => {
                  if (item.value === value.value) return
                  onChange(item)
                }}
              >
                <div className='type-item'>
                  <span>{item.label}</span>
                  {item.value === value.value && <i className='iconfont icon-check'></i>}
                </div>
              </div>
            )
          })
        }

      </IonContent>
    </IonModal>
  )
}

export default observer(CouponType)
